<template>
    <div class="r2d-landing" data-cy="presentation_page">
        <header class="r2d-header" :class="{ 'r2d-header--scrolled': scrolled }">
            <div class="r2d-container d-flex align-items-center justify-content-between">
                <a href="#inicio" class="r2d-brand" @click.prevent="scrollTo('inicio')">
                    <img src="@/assets/img/logo-pb.png" alt="R2 Soft">
                    <span class="r2d-brand__product">Disponibilidade</span>
                </a>

                <nav class="r2d-nav" :class="{ 'r2d-nav--open': menuOpen }">
                    <a v-for="item in navItems" :key="item.id" :href="'#' + item.id"
                       @click.prevent="scrollTo(item.id)">{{ item.label }}</a>
                    <router-link :to="{ name: 'Login' }" class="r2d-btn r2d-btn--primary r2d-btn--sm"
                                 data-cy="presentation_header_login">
                        Entrar no sistema
                    </router-link>
                </nav>

                <button type="button" class="r2d-nav-toggle" aria-label="Abrir menu" @click="menuOpen = !menuOpen">
                    <i :class="menuOpen ? 'fas fa-times' : 'fas fa-bars'"></i>
                </button>
            </div>
        </header>

        <section id="inicio" class="r2d-hero">
            <div class="r2d-hero__glow r2d-hero__glow--one"></div>
            <div class="r2d-hero__glow r2d-hero__glow--two"></div>
            <div class="r2d-hero__grid-bg"></div>

            <div class="r2d-container">
                <div class="row align-items-center">
                    <div class="col-lg-5">
                        <a href="#integracoes" class="r2d-badge" @click.prevent="scrollTo('integracoes')">
                            <span class="r2d-badge__label">Integrado</span>
                            Venda direto no R2 Loteamentos (ERP)
                            <i class="fas fa-arrow-right"></i>
                        </a>
                        <h1 class="r2d-hero__title">
                            Da vitrine do lote à <span>venda assinada</span>, no mesmo painel
                        </h1>
                        <p class="r2d-hero__subtitle">
                            O R2 Disponibilidade conecta loteadora, imobiliárias e corretores em um fluxo único:
                            disponibilidade em tempo real, reserva com prazo, simulação, proposta, contrato e
                            assinatura eletrônica.
                        </p>
                        <div class="r2d-hero__actions">
                            <router-link :to="{ name: 'Login' }" class="r2d-btn r2d-btn--primary"
                                         data-cy="presentation_hero_login">
                                Entrar no sistema <i class="fas fa-arrow-right ml-2"></i>
                            </router-link>
                            <a href="#recursos" class="r2d-btn r2d-btn--link" @click.prevent="scrollTo('recursos')">
                                Conhecer os recursos <i class="fas fa-chevron-down ml-2"></i>
                            </a>
                        </div>
                        <ul class="r2d-highlights">
                            <li v-for="highlight in heroHighlights" :key="highlight">
                                <i class="fas fa-check"></i>{{ highlight }}
                            </li>
                        </ul>
                    </div>

                    <div class="col-lg-7">
                        <div class="r2d-visual">
                            <div class="r2d-window">
                                <div class="r2d-window__bar">
                                    <span class="r2d-window__dots"><i></i><i></i><i></i></span>
                                    <span class="r2d-window__url">
                                        <i class="fas fa-lock"></i> disponibilidade.r2soft.app/lote
                                    </span>
                                </div>

                                <div class="r2d-app" aria-hidden="true">
                                    <aside class="r2d-app__sidebar">
                                        <img src="@/assets/img/logo-pb.png" alt="" class="r2d-app__logo">
                                        <span v-for="item in systemMenu" :key="item.label" class="r2d-app__menu-item"
                                              :class="{ 'r2d-app__menu-item--active': item.active }">
                                            <i :class="item.icon"></i>{{ item.label }}
                                        </span>
                                    </aside>

                                    <div class="r2d-app__page">
                                        <div class="r2d-app__header">
                                            <i class="fas fa-bars"></i>
                                            <span class="r2d-app__company">Residencial Vale Verde</span>
                                            <span class="r2d-app__avatar">CR</span>
                                        </div>

                                        <div class="r2d-app__content">
                                            <div class="r2d-app__title">
                                                <strong>Lotes</strong>
                                                <span class="r2d-app__new">+ Novo</span>
                                            </div>

                                            <div class="r2d-app__card r2d-app__legend">
                                                <span v-for="status in systemStatuses" :key="status.key">
                                                    <i class="fas fa-tag" :style="{ color: status.bg }"></i>{{ status.name }}
                                                </span>
                                            </div>

                                            <div class="r2d-app__card">
                                                <div class="r2d-app__filters-title">
                                                    <i class="fas fa-search"></i> Filtros
                                                </div>
                                                <div class="r2d-app__filters">
                                                    <div v-for="filter in systemFilters" :key="filter.label">
                                                        <small>{{ filter.label }}</small>
                                                        <span>{{ filter.value }}<i class="fas fa-caret-down"></i></span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="r2d-app__block">
                                                <div class="r2d-app__block-head">
                                                    <span class="r2d-app__block-title"><i class="fas fa-th"></i> Quadra A</span>
                                                    <span class="r2d-app__counts">
                                                        <span v-for="count in systemStatusCounts" :key="count.key">
                                                            <strong>{{ count.total }}</strong> {{ count.name }}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div class="r2d-app__lots">
                                                    <div v-for="lot in systemLots" :key="lot.name" class="r2d-app__lot"
                                                         :style="{ background: lot.status.bg, color: lot.status.text }">
                                                        <strong>{{ lot.name }}</strong>
                                                        <span>Lote</span>
                                                        <span>{{ lot.area }} m²</span>
                                                        <b>{{ lot.price }}</b>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="r2d-app__block r2d-app__block--closed">
                                                <div class="r2d-app__block-head">
                                                    <span class="r2d-app__block-title"><i class="fas fa-th"></i> Quadra B</span>
                                                    <i class="fas fa-chevron-down"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="r2d-toast">
                                <i class="fas fa-check-circle"></i>
                                <span>Reserva criada com sucesso!</span>
                            </div>

                            <div class="r2d-glass r2d-glass--toast r2d-glass--whatsapp">
                                <span class="r2d-glass__icon"><i class="fab fa-whatsapp"></i></span>
                                <div>
                                    <strong>Nova reserva · Quadra A, Lote 04</strong>
                                    <small>Aviso enviado aos gestores e ao corretor</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="r2d-stats">
                    <div v-for="stat in heroStats" :key="stat.label" class="r2d-stats__item">
                        <strong>{{ stat.value }}</strong>
                        <span>{{ stat.label }}</span>
                    </div>
                </div>
            </div>
        </section>

        <section id="recursos" class="r2d-section">
            <div class="r2d-container">
                <div class="r2d-section__head">
                    <span class="r2d-eyebrow">Recursos</span>
                    <h2>Tudo o que a operação comercial do loteamento precisa</h2>
                    <p>Do primeiro contato do cliente até a venda registrada no R2 Loteamentos (ERP), sem planilha paralela e sem
                        retrabalho.</p>
                </div>

                <div v-for="(showcase, index) in showcases" :key="showcase.title"
                     class="r2d-showcase" :class="{ 'r2d-showcase--reverse': index % 2 === 1 }">
                    <div class="r2d-showcase__icon">
                        <i :class="showcase.icon"></i>
                    </div>
                    <div class="r2d-showcase__body">
                        <span class="r2d-tag">{{ showcase.tag }}</span>
                        <h3>{{ showcase.title }}</h3>
                        <p>{{ showcase.text }}</p>
                        <ul>
                            <li v-for="point in showcase.points" :key="point">
                                <i class="fas fa-check"></i>{{ point }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section id="solucoes" class="r2d-section r2d-section--alt">
            <div class="r2d-container">
                <div class="r2d-section__head">
                    <span class="r2d-eyebrow">Funcionalidades</span>
                    <h2>Uma plataforma completa, módulo a módulo</h2>
                </div>
                <div class="row">
                    <div v-for="feature in features" :key="feature.title" class="col-md-6 col-lg-3 mb-4">
                        <div class="r2d-card">
                            <i :class="feature.icon"></i>
                            <h4>{{ feature.title }}</h4>
                            <p>{{ feature.text }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="para-quem" class="r2d-section">
            <div class="r2d-container">
                <div class="r2d-section__head">
                    <span class="r2d-eyebrow">Para quem</span>
                    <h2>Cada perfil enxerga exatamente o que precisa</h2>
                </div>
                <div class="row">
                    <div v-for="audience in audiences" :key="audience.title" class="col-lg-4 mb-4">
                        <div class="r2d-audience">
                            <div class="r2d-audience__head">
                                <i :class="audience.icon"></i>
                                <h4>{{ audience.title }}</h4>
                            </div>
                            <ul>
                                <li v-for="point in audience.points" :key="point">
                                    <i class="fas fa-check-circle"></i>{{ point }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="como-funciona" class="r2d-section r2d-section--alt">
            <div class="r2d-container">
                <div class="r2d-section__head">
                    <span class="r2d-eyebrow">Passo a passo</span>
                    <h2>Como funciona</h2>
                </div>
                <div class="r2d-steps">
                    <div v-for="(step, index) in steps" :key="step.title" class="r2d-step">
                        <span class="r2d-step__number">{{ index + 1 }}</span>
                        <h4>{{ step.title }}</h4>
                        <p>{{ step.text }}</p>
                    </div>
                </div>
            </div>
        </section>

        <section id="integracoes" class="r2d-section">
            <div class="r2d-container">
                <div class="r2d-section__head">
                    <span class="r2d-eyebrow">Integrações</span>
                    <h2>Conectado ao ecossistema que você já usa</h2>
                    <p>Integração nativa com o R2 Loteamentos (ERP) e com as ferramentas do dia a dia comercial.</p>
                </div>
                <div class="row justify-content-center">
                    <div v-for="integration in integrations" :key="integration.title" class="col-md-6 col-lg-4 mb-4">
                        <div class="r2d-integration">
                            <i :class="integration.icon"></i>
                            <div>
                                <h5>{{ integration.title }}</h5>
                                <p>{{ integration.text }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="r2d-about">
                    <div>
                        <span class="r2d-eyebrow">Quem somos</span>
                        <p class="mb-0">
                            <strong>R2 SOFT DESENVOLVIMENTO DE SOFTWARE LTDA</strong> · CNPJ 15.401.765/0001-00
                        </p>
                    </div>
                    <p class="mb-0">
                        Dados de clientes tratados apenas para a operação comercial, com permissões por perfil
                        e por empreendimento (LGPD).
                    </p>
                </div>
            </div>
        </section>

        <section id="duvidas" class="r2d-section r2d-section--alt">
            <div class="r2d-container r2d-container--narrow">
                <div class="r2d-section__head">
                    <span class="r2d-eyebrow">Dúvidas</span>
                    <h2>Perguntas frequentes</h2>
                </div>
                <div v-for="(faq, index) in faqs" :key="faq.question" class="r2d-faq"
                     :class="{ 'r2d-faq--open': openFaq === index }">
                    <button type="button" class="r2d-faq__question" @click="toggleFaq(index)">
                        {{ faq.question }}
                        <i class="fas fa-chevron-down"></i>
                    </button>
                    <div v-show="openFaq === index" class="r2d-faq__answer">{{ faq.answer }}</div>
                </div>
            </div>
        </section>

        <section class="r2d-cta">
            <div class="r2d-container text-center">
                <h2>Quer ver o espelho de vendas, as reservas e as propostas rodando no mesmo fluxo?</h2>
                <p>Entre no sistema ou fale com o nosso time para uma apresentação com os dados do seu
                    empreendimento.</p>
                <div class="r2d-hero__actions justify-content-center">
                    <router-link :to="{ name: 'Login' }" class="r2d-btn r2d-btn--primary">
                        Entrar no sistema <i class="fas fa-arrow-right ml-2"></i>
                    </router-link>
                </div>
            </div>
        </section>

        <footer class="r2d-footer">
            <div class="r2d-container">
                <div class="row">
                    <div class="col-lg-5 mb-4">
                        <img src="@/assets/img/logo-pb.png" alt="R2 Soft" class="r2d-footer__logo">
                        <p>Espelho de vendas, reservas, propostas, contratos e assinatura eletrônica para loteadoras,
                            imobiliárias e corretores.</p>
                    </div>
                    <div class="col-6 col-lg-2 mb-4">
                        <h6>Produto</h6>
                        <a href="#inicio" @click.prevent="scrollTo('inicio')">Início</a>
                        <a href="#solucoes" @click.prevent="scrollTo('solucoes')">Funcionalidades</a>
                        <router-link :to="{ name: 'Login' }">Acessar app</router-link>
                    </div>
                    <div class="col-6 col-lg-2 mb-4">
                        <h6>Ecossistema</h6>
                        <span>R2 Loteamentos</span>
                        <span>R2 Atende +</span>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <h6>Contato</h6>
                        <a :href="contactLink">+55 62 8129-4907</a>
                        <a :href="'mailto:' + contactEmail">{{ contactEmail }}</a>
                    </div>
                </div>
                <div class="r2d-footer__bottom">
                    © {{ currentYear }} R2 SOFT DESENVOLVIMENTO DE SOFTWARE LTDA — CNPJ: 15.401.765/0001-00
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'presentationComponent',
    data() {
        return {
            scrolled: false,
            menuOpen: false,
            openFaq: 0,
            contactEmail: 'suporte@r2soft.com.br',
            navItems: [
                {id: 'recursos', label: 'Recursos'},
                {id: 'solucoes', label: 'Funcionalidades'},
                {id: 'como-funciona', label: 'Como funciona'},
                {id: 'integracoes', label: 'Integrações'},
                {id: 'duvidas', label: 'Dúvidas'},
            ],
            heroHighlights: [
                'Reservas que expiram sozinhas',
                'Assinatura eletrônica via ClickSign',
                'Avisos automáticos no WhatsApp',
            ],
            systemMenu: [
                {icon: 'fas fa-home', label: 'Home'},
                {icon: 'fas fa-map', label: 'Loteamentos'},
                {icon: 'fas fa-th', label: 'Lotes', active: true},
                {icon: 'fas fa-bookmark', label: 'Reservas'},
                {icon: 'fas fa-file-invoice-dollar', label: 'Propostas'},
                {icon: 'fas fa-users', label: 'Pessoas'},
                {icon: 'fas fa-file-contract', label: 'Contratos'},
                {icon: 'fas fa-chart-pie', label: 'Dashboard'},
            ],
            systemFilters: [
                {label: 'Loteamentos', value: 'Residencial Vale Verde'},
                {label: 'Etapas', value: 'Etapa 1'},
                {label: 'Situação', value: 'Selecione'},
                {label: 'Proprietários', value: 'Selecione'},
            ],
            systemStatuses: [
                {key: 'available', name: 'Disponível', bg: '#98fb98', text: '#0b3d2e'},
                {key: 'reserved', name: 'Reservado', bg: '#b5b5b5', text: '#1b1b1b'},
                {key: 'confirmed', name: 'Reserva Confirmada', bg: '#8e2b2b', text: '#ffffff'},
                {key: 'sold', name: 'Vendido', bg: '#e04848', text: '#ffffff'},
                {key: 'blocked', name: 'Bloqueado', bg: '#1e90ff', text: '#ffffff'},
            ],
            showcases: [
                {
                    tag: 'Disponibilidade',
                    icon: 'fas fa-th',
                    title: 'Espelho de vendas sempre atualizado',
                    text: 'Visualize todos os lotes por quadra e etapa, com status, metragem, tipo e preço. '
                        + 'Cada reserva, proposta ou venda muda o status na hora para toda a equipe comercial.',
                    points: [
                        'Status configuráveis e alteração em massa',
                        'Filtros por loteamento, quadra, etapa e situação',
                        'Mapas e vitrine pública para o cliente final',
                    ],
                },
                {
                    tag: 'Reservas',
                    icon: 'fas fa-hourglass-half',
                    title: 'Reserva com prazo e expiração automática',
                    text: 'O corretor reserva o lote em poucos passos, com tipo de reserva e tempo de permanência '
                        + 'definidos pela loteadora. Reserva vencida volta a ficar disponível sozinha.',
                    points: [
                        'Prorrogação de prazo controlada pelo gestor',
                        'Aviso automático de nova reserva por WhatsApp',
                        'Histórico completo por lote e por cliente',
                    ],
                },
                {
                    tag: 'Comercial',
                    icon: 'fas fa-calculator',
                    title: 'Simulação, proposta e contrato no mesmo fluxo',
                    text: 'Simule entrada, parcelas e correção monetária conforme as regras de cada empreendimento, '
                        + 'gere a proposta e transforme a aprovação em contrato a partir dos seus próprios modelos.',
                    points: [
                        'Simulador com fórmulas, descontos e índices de correção',
                        'Aprovação, pendência e reprovação de propostas',
                        'Modelos de contrato com campos preenchidos automaticamente',
                    ],
                },
                {
                    tag: 'Fechamento',
                    icon: 'fas fa-file-signature',
                    title: 'Assinatura eletrônica e venda direto no R2 Loteamentos (ERP)',
                    text: 'Envie propostas e contratos para assinatura eletrônica via ClickSign e acompanhe cada '
                        + 'signatário. Com a venda confirmada, os dados seguem para o R2 Loteamentos sem redigitação.',
                    points: [
                        'Acompanhamento de assinaturas em tempo real',
                        'Envio da venda confirmada para o R2 Loteamentos',
                        'Webhooks para integrar com outros sistemas',
                    ],
                },
            ],
            features: [
                {icon: 'fas fa-map-marked-alt', title: 'Loteamentos e lotes', text: 'Cadastro de empreendimentos, etapas, quadras, lotes e tipos de imóvel, com importação do R2 Loteamentos (ERP).'},
                {icon: 'fas fa-bookmark', title: 'Reservas', text: 'Tipos de reserva, prazos, prorrogação, confirmação e expiração automática.'},
                {icon: 'fas fa-calculator', title: 'Simulador de financiamento', text: 'Configurações por loteamento com fórmulas, descontos, parcelas concorrentes e correção monetária.'},
                {icon: 'fas fa-tags', title: 'Tabela de preços e reajustes', text: 'Importação e exportação em Excel e reajuste de preços em massa por índices.'},
                {icon: 'fas fa-file-invoice-dollar', title: 'Propostas', text: 'Proposta com formas de pagamento, painel de acompanhamento e fluxo de aprovação.'},
                {icon: 'fas fa-file-contract', title: 'Contratos', text: 'Modelos com campos dinâmicos que geram o contrato pronto em PDF.'},
                {icon: 'fas fa-signature', title: 'Assinatura eletrônica', text: 'Integração com ClickSign para assinatura eletrônica de propostas e contratos.'},
                {icon: 'fas fa-users', title: 'Clientes', text: 'Cadastro completo do comprador e dashboard com o perfil por idade, renda, cidade e profissão.'},
                {icon: 'fas fa-user-tie', title: 'Corretores e imobiliárias', text: 'Usuários vinculados a cada empreendimento, com permissões e link próprio de cadastro.'},
                {icon: 'fas fa-hand-holding-usd', title: 'Comissões', text: 'Acompanhamento das comissões da rede de corretores e imobiliárias.'},
                {icon: 'fas fa-globe', title: 'Área pública', text: 'Vitrine de lotes e mapas configuráveis para clientes e corretores consultarem sem login.'},
                {icon: 'fas fa-stream', title: 'Cronograma de obras', text: 'Cronograma em Gantt do empreendimento, com link público para compartilhar.'},
                {icon: 'fas fa-folder-open', title: 'Documentos', text: 'Anexos organizados por tipo, vinculados ao cliente e à negociação.'},
                {icon: 'fas fa-tasks', title: 'Tarefas e responsáveis', text: 'Distribuição de tarefas por etapa e responsável para não perder prazos.'},
                {icon: 'fas fa-chart-pie', title: 'Dashboards', text: 'Resumo de lotes, reservas e propostas por loteamento para a gestão.'},
                {icon: 'fas fa-building', title: 'Multiempresa e permissões', text: 'Ambiente isolado por empresa, perfis de acesso e regras de validação configuráveis.'},
            ],
            audiences: [
                {
                    icon: 'fas fa-city',
                    title: 'Loteadoras e incorporadoras',
                    points: [
                        'Controle total da disponibilidade de todos os empreendimentos',
                        'Regras de preço, reserva e financiamento centralizadas',
                        'Venda confirmada direto no R2 Loteamentos',
                        'Indicadores de vendas e perfil dos compradores',
                    ],
                },
                {
                    icon: 'fas fa-store',
                    title: 'Imobiliárias parceiras',
                    points: [
                        'Gestão da própria equipe de corretores',
                        'Acesso apenas aos empreendimentos liberados',
                        'Acompanhamento de reservas, propostas e comissões',
                    ],
                },
                {
                    icon: 'fas fa-user-tie',
                    title: 'Corretores',
                    points: [
                        'Espelho de vendas atualizado no celular',
                        'Reserva, simulação e proposta em poucos cliques',
                        'Link próprio para captar clientes',
                        'Aviso no WhatsApp a cada movimentação',
                    ],
                },
            ],
            steps: [
                {title: 'Importe seus empreendimentos', text: 'Traga loteamentos, etapas e lotes do R2 Loteamentos ou cadastre direto no sistema.'},
                {title: 'Configure as regras', text: 'Defina tabela de preços, tipos de reserva, simulador, modelos de proposta e contrato.'},
                {title: 'Convide sua rede', text: 'Libere imobiliárias e corretores por empreendimento, com o perfil de acesso de cada um.'},
                {title: 'Reserve e negocie', text: 'O corretor reserva o lote, simula e envia a proposta; o gestor aprova no painel.'},
                {title: 'Assine e conclua', text: 'Contrato assinado pela ClickSign e venda enviada automaticamente ao R2 Loteamentos (ERP).'},
            ],
            integrations: [
                {icon: 'fas fa-cubes', title: 'R2 Loteamentos (ERP)', text: 'Importação de loteamentos e lotes e envio automático das vendas confirmadas.'},
                {icon: 'fas fa-signature', title: 'ClickSign', text: 'Assinatura eletrônica de propostas e contratos, com acompanhamento dos signatários.'},
                {icon: 'fab fa-whatsapp', title: 'WhatsApp', text: 'Avisos automáticos de novas reservas e movimentações para gestores e corretores.'},
                {icon: 'fas fa-envelope', title: 'E-mail', text: 'Envio de links de cadastro e comunicações para clientes e usuários.'},
                {icon: 'fas fa-plug', title: 'Webhooks', text: 'Eventos de lote, reserva, etapa e venda para integrar com qualquer sistema, com reenvio automático.'},
            ],
            faqs: [
                {
                    question: 'Preciso usar o R2 Loteamentos para contratar o R2 Disponibilidade?',
                    answer: 'Não. O R2 Disponibilidade funciona de forma independente, mas a integração nativa com o '
                        + 'R2 Loteamentos elimina a redigitação: loteamentos e lotes são importados e a venda '
                        + 'confirmada segue automaticamente para o R2 Loteamentos (ERP).',
                },
                {
                    question: 'Imobiliárias e corretores parceiros podem usar o sistema?',
                    answer: 'Sim. Cada imobiliária e corretor recebe acesso apenas aos empreendimentos liberados pela '
                        + 'loteadora, com permissões por perfil.',
                },
                {
                    question: 'O que acontece quando uma reserva vence?',
                    answer: 'O lote volta automaticamente a ficar disponível no espelho de vendas, conforme o prazo '
                        + 'definido no tipo de reserva. O gestor pode prorrogar o prazo quando necessário.',
                },
                {
                    question: 'Consigo simular o financiamento com as regras do meu empreendimento?',
                    answer: 'Sim. O simulador é configurado por loteamento, com fórmulas, descontos, parcelas e índices '
                        + 'de correção monetária.',
                },
                {
                    question: 'Os contratos podem ser assinados digitalmente?',
                    answer: 'Sim. Propostas e contratos são enviados para assinatura eletrônica pela ClickSign, e o '
                        + 'andamento de cada signatário fica visível no sistema.',
                },
                {
                    question: 'O cliente final consegue ver os lotes disponíveis?',
                    answer: 'Sim. A área pública exibe lotes e mapas do empreendimento em uma página configurável, '
                        + 'sem necessidade de login.',
                },
            ],
        };
    },
    computed: {
        systemLots() {
            const pattern = ['available', 'sold', 'available', 'reserved', 'available', 'sold', 'confirmed', 'available',
                'sold', 'available', 'blocked', 'available'];
            const areas = [360, 375, 360, 420, 390, 360, 450, 380, 360, 400, 360, 410];
            const statuses = Object.fromEntries(this.systemStatuses.map(status => [status.key, status]));
            return pattern.map((key, index) => ({
                name: String(index + 1).padStart(2, '0'),
                area: areas[index],
                price: (areas[index] * 525).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}),
                status: statuses[key],
            }));
        },
        systemStatusCounts() {
            return this.systemStatuses
                .map(status => ({
                    key: status.key,
                    name: status.name,
                    total: this.systemLots.filter(lot => lot.status.key === status.key).length,
                }))
                .filter(count => count.total > 0);
        },
        contactLink() {
            return 'mailto:' + this.contactEmail + '?subject=' + encodeURIComponent('Apresentação R2 Disponibilidade');
        },
        currentYear() {
            return new Date().getFullYear();
        },
    },
    mounted() {
        // O layout público adiciona essa classe ao body (flex centralizado) e ela persiste na navegação SPA
        document.body.classList.remove('authentication');
        window.addEventListener('scroll', this.onScroll, {passive: true});
        this.onScroll();
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.onScroll);
    },
    methods: {
        onScroll() {
            this.scrolled = window.scrollY > 10;
        },
        scrollTo(id) {
            this.menuOpen = false;
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({behavior: 'smooth', block: 'start'});
            }
        },
        toggleFaq(index) {
            this.openFaq = this.openFaq === index ? null : index;
        },
    },
};
</script>

<style scoped>
.r2d-landing {
    --r2d-primary: #0e5e4e;
    --r2d-primary-light: #2bb58f;
    --r2d-accent: #7fe0c2;
    --r2d-bg: #0b1a17;
    --r2d-bg-alt: #0f2420;
    --r2d-surface: rgba(255, 255, 255, 0.04);
    --r2d-border: rgba(255, 255, 255, 0.09);
    --r2d-text: #e6efec;
    --r2d-muted: #9fb5ae;
    font-family: 'Open Sans', sans-serif;
    font-size: 1rem;
    color: var(--r2d-text);
    background: var(--r2d-bg);
    min-height: 100vh;
    text-align: left;
    overflow-x: hidden;
}

.r2d-container {
    max-width: 1180px;
    margin: 0 auto;
    padding: 0 20px;
}

.r2d-container--narrow {
    max-width: 820px;
}

.r2d-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    padding: 18px 0;
    transition: background 0.25s, padding 0.25s;
}

.r2d-header--scrolled {
    background: rgba(11, 26, 23, 0.88);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid var(--r2d-border);
    padding: 10px 0;
}

.r2d-brand {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
}

.r2d-brand img {
    height: 34px;
}

.r2d-brand__product {
    color: var(--r2d-accent);
    font-weight: 700;
    font-size: 1.05rem;
    border-left: 1px solid var(--r2d-border);
    padding-left: 10px;
}

.r2d-nav {
    display: flex;
    align-items: center;
    gap: 26px;
}

.r2d-nav a:not(.r2d-btn) {
    color: var(--r2d-muted);
    font-weight: 600;
    font-size: 0.9rem;
    text-decoration: none;
}

.r2d-nav a:not(.r2d-btn):hover {
    color: var(--r2d-text);
}

.r2d-nav-toggle {
    display: none;
    background: var(--r2d-surface);
    border: 1px solid var(--r2d-border);
    color: var(--r2d-text);
    border-radius: 10px;
    width: 42px;
    height: 42px;
}

.r2d-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 13px 26px;
    border-radius: 12px;
    font-weight: 700;
    font-size: 0.95rem;
    text-decoration: none;
    border: 1px solid transparent;
    transition: transform 0.15s, box-shadow 0.15s, background 0.15s;
}

.r2d-btn:hover {
    text-decoration: none;
    transform: translateY(-1px);
}

.r2d-btn--sm {
    padding: 9px 18px;
    font-size: 0.85rem;
}

.r2d-btn--primary {
    background: linear-gradient(135deg, var(--r2d-primary-light), var(--r2d-primary));
    color: #fff;
    box-shadow: 0 10px 30px rgba(43, 181, 143, 0.25);
}

.r2d-btn--primary:hover {
    color: #fff;
    box-shadow: 0 14px 34px rgba(43, 181, 143, 0.35);
}

.r2d-btn--ghost {
    color: var(--r2d-text);
    border-color: var(--r2d-border);
    background: var(--r2d-surface);
}

.r2d-btn--ghost:hover {
    color: var(--r2d-text);
    background: rgba(255, 255, 255, 0.08);
}

.r2d-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: var(--r2d-accent);
    text-transform: uppercase;
    letter-spacing: 0.12em;
    font-size: 0.75rem;
    font-weight: 700;
    margin-bottom: 14px;
}

.r2d-eyebrow::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--r2d-primary-light);
}

.r2d-hero {
    position: relative;
    overflow: hidden;
    padding: 160px 0 80px;
}

.r2d-hero > .r2d-container {
    position: relative;
    z-index: 1;
}

.r2d-hero__glow {
    position: absolute;
    border-radius: 50%;
    filter: blur(90px);
    pointer-events: none;
    animation: r2d-drift 14s ease-in-out infinite;
}

.r2d-hero__glow--one {
    width: 560px;
    height: 560px;
    top: -160px;
    right: -120px;
    background: rgba(43, 181, 143, 0.22);
}

.r2d-hero__glow--two {
    width: 460px;
    height: 460px;
    bottom: -180px;
    left: -160px;
    background: rgba(14, 94, 78, 0.45);
    animation-delay: -7s;
}

.r2d-hero__grid-bg {
    position: absolute;
    inset: 0;
    background-image: linear-gradient(rgba(255, 255, 255, 0.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.035) 1px, transparent 1px);
    background-size: 56px 56px;
    -webkit-mask-image: radial-gradient(ellipse at 60% 30%, #000 20%, transparent 70%);
    mask-image: radial-gradient(ellipse at 60% 30%, #000 20%, transparent 70%);
    pointer-events: none;
}

.r2d-badge {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 5px 14px 5px 5px;
    margin-bottom: 24px;
    border-radius: 999px;
    border: 1px solid rgba(127, 224, 194, 0.25);
    background: rgba(127, 224, 194, 0.06);
    color: var(--r2d-text);
    font-size: 0.82rem;
    font-weight: 600;
    text-decoration: none;
    transition: border-color 0.2s, background 0.2s;
}

.r2d-badge:hover {
    color: var(--r2d-text);
    text-decoration: none;
    border-color: rgba(127, 224, 194, 0.5);
    background: rgba(127, 224, 194, 0.1);
}

.r2d-badge__label {
    padding: 3px 10px;
    border-radius: 999px;
    background: linear-gradient(135deg, var(--r2d-primary-light), var(--r2d-primary));
    color: #fff;
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
}

.r2d-badge i {
    font-size: 0.7rem;
    color: var(--r2d-accent);
}

.r2d-hero__title {
    font-size: 3.4rem;
    font-weight: 800;
    line-height: 1.06;
    letter-spacing: -0.03em;
    color: #fff;
    margin-bottom: 22px;
}

.r2d-hero__title span {
    background: linear-gradient(120deg, #b8f5e2 0%, var(--r2d-accent) 40%, var(--r2d-primary-light) 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

.r2d-hero__subtitle {
    color: var(--r2d-muted);
    font-size: 1.12rem;
    line-height: 1.75;
    margin-bottom: 34px;
    max-width: 520px;
}

.r2d-hero__actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 14px;
    margin-bottom: 30px;
}

.r2d-btn--link {
    color: var(--r2d-text);
    padding-left: 10px;
    padding-right: 10px;
}

.r2d-btn--link:hover {
    color: var(--r2d-accent);
}

.r2d-btn--link i {
    font-size: 0.75rem;
}

.r2d-highlights {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0;
    margin: 0;
    list-style: none;
    color: var(--r2d-muted);
    font-size: 0.92rem;
}

.r2d-highlights i {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    border-radius: 50%;
    background: rgba(43, 181, 143, 0.15);
    color: var(--r2d-accent);
    font-size: 0.6rem;
}

.r2d-visual {
    position: relative;
    margin: 0 0 0 30px;
    perspective: 1800px;
}

.r2d-window {
    position: relative;
    overflow: hidden;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: #eff1f5;
    box-shadow: 0 50px 100px -20px rgba(0, 0, 0, 0.65), 0 0 80px -10px rgba(43, 181, 143, 0.3);
    transform: rotateY(-5deg) rotateX(2deg);
}

.r2d-window__bar {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 9px 14px;
    background: #e3e6eb;
    border-bottom: 1px solid #d7dbe2;
}

.r2d-window__dots {
    display: flex;
    gap: 6px;
}

.r2d-window__dots i {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #c4c9d1;
}

.r2d-window__dots i:first-child {
    background: #ee6a5f;
}

.r2d-window__dots i:nth-child(2) {
    background: #f5be4f;
}

.r2d-window__dots i:last-child {
    background: #62c454;
}

.r2d-window__url {
    flex: 1;
    max-width: 300px;
    margin: 0 auto;
    padding: 4px 12px;
    border-radius: 7px;
    background: #f6f8fa;
    color: #777b82;
    font-size: 0.68rem;
    text-align: center;
}

.r2d-window__url i {
    font-size: 0.58rem;
    margin-right: 4px;
    color: #0e5e4e;
}

.r2d-app {
    display: flex;
    min-height: 400px;
    color: #333333;
    font-size: 0.62rem;
}

.r2d-app__sidebar {
    flex: 0 0 128px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 12px 10px 12px 0;
    background: #191919;
}

.r2d-app__logo {
    height: 20px;
    margin: 0 0 14px 12px;
    align-self: flex-start;
}

.r2d-app__menu-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    color: #abaaaf;
    border-radius: 0 14px 14px 0;
    white-space: nowrap;
}

.r2d-app__menu-item i {
    width: 12px;
    color: #727176;
    text-align: center;
}

.r2d-app__menu-item--active {
    color: #ffffff;
    background: linear-gradient(90deg, rgba(14, 94, 78, 0.55), rgba(14, 94, 78, 0.12));
}

.r2d-app__menu-item--active i {
    color: #2bb58f;
}

.r2d-app__page {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.r2d-app__header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 14px;
    background: #f6f8fa;
    border-bottom: 1px solid #d7dbe2;
    color: #595959;
}

.r2d-app__company {
    margin: 0 auto;
    padding: 3px 12px;
    border-radius: 6px;
    background: #ffffff;
    border: 1px solid #d7dbe2;
    font-weight: 600;
}

.r2d-app__avatar {
    margin-left: auto;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #0e5e4e;
    color: #ffffff;
    font-size: 0.55rem;
    font-weight: 700;
}

.r2d-app__content {
    padding: 10px 12px 12px;
}

.r2d-app__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.r2d-app__title strong {
    font-size: 0.85rem;
    color: #1b1b1b;
}

.r2d-app__new {
    padding: 3px 10px;
    border-radius: 5px;
    background: #0e5e4e;
    color: #ffffff;
    font-weight: 700;
}

.r2d-app__card {
    margin-bottom: 6px;
    padding: 8px 10px;
    border-radius: 8px;
    background: #f6f8fa;
    box-shadow: 0 0 10px #e5e9ec;
    border-bottom: 1px solid #d7dbe2;
}

.r2d-app__legend {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 12px;
}

.r2d-app__legend i {
    margin-right: 4px;
}

.r2d-app__filters-title {
    margin-bottom: 6px;
    font-weight: 700;
    color: #1b1b1b;
}

.r2d-app__filters-title i {
    padding: 3px;
    margin-right: 4px;
    border-radius: 4px;
    background: #0e5e4e;
    color: #ffffff;
    font-size: 0.5rem;
}

.r2d-app__filters {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
}

.r2d-app__filters small {
    display: block;
    margin-bottom: 2px;
    font-size: 0.55rem;
    font-weight: 600;
    color: #595959;
}

.r2d-app__filters span {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 3px 6px;
    border-radius: 4px;
    border: 1px solid #cecece;
    background: #ffffff;
    white-space: nowrap;
    overflow: hidden;
}

.r2d-app__filters span i {
    color: #888888;
}

.r2d-app__block {
    margin-bottom: 6px;
    border-radius: 8px;
    background: #f6f8fa;
    box-shadow: 0 0 10px #e5e9ec;
    border-bottom: 1px solid #d7dbe2;
}

.r2d-app__block-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 7px 10px;
    border-bottom: 1px solid #d7dbe2;
    color: #0e5e4e;
    font-weight: 700;
}

.r2d-app__block--closed .r2d-app__block-head {
    border-bottom: 0;
    color: #333333;
}

.r2d-app__block-title i {
    padding: 4px;
    margin-right: 4px;
    border-radius: 5px;
    background: #e7f4f0;
    color: #0e5e4e;
    font-size: 0.5rem;
}

.r2d-app__counts {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 3px;
}

.r2d-app__counts span {
    padding: 1px 6px;
    border-radius: 999px;
    background: rgba(231, 244, 240, 0.9);
    box-shadow: inset 0 0 0 1px rgba(14, 94, 78, 0.08);
    color: #0e5e4e;
    font-size: 0.52rem;
    white-space: nowrap;
}

.r2d-app__counts strong {
    color: #0a4c40;
}

.r2d-app__lots {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 6px;
    padding: 8px 10px 10px;
}

.r2d-app__lot {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px 2px;
    border-radius: 6px;
    line-height: 1.35;
    text-align: center;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.r2d-app__lot strong {
    font-size: 0.8rem;
}

.r2d-app__lot span {
    font-size: 0.52rem;
}

.r2d-app__lot b {
    font-size: 0.54rem;
    white-space: nowrap;
}

.r2d-toast {
    position: absolute;
    z-index: 2;
    top: 52px;
    right: -22px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 18px;
    border-radius: 8px;
    background: #4caf50;
    color: #ffffff;
    font-size: 0.8rem;
    font-weight: 600;
    box-shadow: 0 18px 40px -10px rgba(0, 0, 0, 0.5);
    animation: r2d-float 6s ease-in-out infinite;
}

.r2d-toast i {
    font-size: 1rem;
}

.r2d-glass {
    position: absolute;
    z-index: 2;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(16, 37, 31, 0.8);
    -webkit-backdrop-filter: blur(16px);
    backdrop-filter: blur(16px);
    box-shadow: 0 24px 50px -12px rgba(0, 0, 0, 0.6);
    color: var(--r2d-text);
    animation: r2d-float 6s ease-in-out infinite;
}

.r2d-glass--toast {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    font-size: 0.78rem;
}

.r2d-glass--toast strong,
.r2d-glass--toast small {
    display: block;
}

.r2d-glass--toast strong {
    color: #fff;
}

.r2d-glass--toast small {
    color: var(--r2d-muted);
}

.r2d-glass--whatsapp {
    left: -40px;
    bottom: -34px;
    animation-delay: -3s;
}

.r2d-glass__icon {
    flex: 0 0 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: rgba(37, 211, 102, 0.18);
    color: #25d366;
    font-size: 1.1rem;
}

.r2d-stats {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    margin-top: 110px;
    border: 1px solid var(--r2d-border);
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.025);
    -webkit-backdrop-filter: blur(6px);
    backdrop-filter: blur(6px);
}

.r2d-stats__item {
    padding: 24px 26px;
    border-right: 1px solid var(--r2d-border);
}

.r2d-stats__item:last-child {
    border-right: 0;
}

.r2d-stats__item strong {
    display: block;
    font-size: 2.1rem;
    font-weight: 800;
    letter-spacing: -0.03em;
    background: linear-gradient(120deg, #fff, var(--r2d-accent));
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

.r2d-stats__item span {
    color: var(--r2d-muted);
    font-size: 0.85rem;
}

.r2d-section {
    padding: 90px 0;
}

.r2d-section--alt {
    background: var(--r2d-bg-alt);
}

.r2d-section__head {
    text-align: center;
    max-width: 720px;
    margin: 0 auto 50px;
}

.r2d-section__head h2,
.r2d-cta h2 {
    font-size: 2.1rem;
    font-weight: 800;
    color: #fff;
    margin-bottom: 14px;
}

.r2d-section__head p,
.r2d-cta p {
    color: var(--r2d-muted);
    font-size: 1.05rem;
}

.r2d-showcase {
    display: flex;
    align-items: center;
    gap: 40px;
    padding: 36px;
    margin-bottom: 24px;
    border: 1px solid var(--r2d-border);
    border-radius: 20px;
    background: var(--r2d-surface);
}

.r2d-showcase--reverse {
    flex-direction: row-reverse;
}

.r2d-showcase__icon {
    flex: 0 0 180px;
    height: 180px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, rgba(43, 181, 143, 0.25), rgba(14, 94, 78, 0.15));
    font-size: 4rem;
    color: var(--r2d-accent);
}

.r2d-tag {
    display: inline-block;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--r2d-accent);
    background: rgba(127, 224, 194, 0.1);
    border-radius: 6px;
    padding: 4px 10px;
    margin-bottom: 10px;
}

.r2d-showcase h3 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #fff;
}

.r2d-showcase p,
.r2d-card p,
.r2d-step p,
.r2d-integration p {
    color: var(--r2d-muted);
    line-height: 1.65;
}

.r2d-showcase ul,
.r2d-audience ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.r2d-showcase li,
.r2d-audience li {
    margin-bottom: 8px;
    font-size: 0.95rem;
}

.r2d-showcase li i,
.r2d-audience li i {
    color: var(--r2d-primary-light);
    margin-right: 10px;
}

.r2d-card {
    height: 100%;
    padding: 24px;
    border: 1px solid var(--r2d-border);
    border-radius: 16px;
    background: var(--r2d-surface);
    transition: border-color 0.2s, transform 0.2s;
}

.r2d-card:hover {
    border-color: rgba(43, 181, 143, 0.5);
    transform: translateY(-3px);
}

.r2d-card > i {
    font-size: 1.5rem;
    color: var(--r2d-accent);
    margin-bottom: 14px;
}

.r2d-card h4,
.r2d-step h4 {
    font-size: 1.05rem;
    font-weight: 700;
    color: #fff;
}

.r2d-card p {
    font-size: 0.9rem;
    margin: 0;
}

.r2d-audience {
    height: 100%;
    padding: 30px;
    border-radius: 20px;
    border: 1px solid var(--r2d-border);
    background: linear-gradient(160deg, rgba(43, 181, 143, 0.1), transparent 60%);
}

.r2d-audience__head {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 20px;
}

.r2d-audience__head i {
    font-size: 1.6rem;
    color: var(--r2d-accent);
}

.r2d-audience__head h4 {
    margin: 0;
    font-weight: 700;
    color: #fff;
}

.r2d-steps {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 18px;
}

.r2d-step {
    position: relative;
    padding: 26px 22px;
    border-radius: 16px;
    border: 1px solid var(--r2d-border);
    background: var(--r2d-surface);
}

.r2d-step__number {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--r2d-primary-light), var(--r2d-primary));
    color: #fff;
    font-weight: 800;
    margin-bottom: 14px;
}

.r2d-step p {
    font-size: 0.9rem;
    margin: 0;
}

.r2d-integration {
    display: flex;
    gap: 16px;
    height: 100%;
    padding: 22px;
    border-radius: 16px;
    border: 1px solid var(--r2d-border);
    background: var(--r2d-surface);
}

.r2d-integration > i {
    flex: 0 0 46px;
    height: 46px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(127, 224, 194, 0.1);
    color: var(--r2d-accent);
    font-size: 1.3rem;
}

.r2d-integration h5 {
    font-weight: 700;
    color: #fff;
    font-size: 1rem;
}

.r2d-integration p {
    font-size: 0.88rem;
    margin: 0;
}

.r2d-about {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    margin-top: 30px;
    padding: 26px 30px;
    border-radius: 16px;
    border: 1px dashed var(--r2d-border);
    color: var(--r2d-muted);
}

.r2d-about strong {
    color: var(--r2d-text);
}

.r2d-faq {
    border: 1px solid var(--r2d-border);
    border-radius: 14px;
    background: var(--r2d-surface);
    margin-bottom: 12px;
}

.r2d-faq__question {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 18px 22px;
    background: none;
    border: 0;
    color: var(--r2d-text);
    font-weight: 700;
    font-size: 1rem;
    text-align: left;
}

.r2d-faq__question:focus {
    outline: none;
}

.r2d-faq__question i {
    transition: transform 0.2s;
    color: var(--r2d-accent);
}

.r2d-faq--open .r2d-faq__question i {
    transform: rotate(180deg);
}

.r2d-faq__answer {
    padding: 0 22px 20px;
    color: var(--r2d-muted);
    line-height: 1.65;
}

.r2d-cta {
    padding: 90px 0;
    background: radial-gradient(circle at 50% 0%, rgba(43, 181, 143, 0.25), transparent 60%), var(--r2d-bg);
}

.r2d-cta h2 {
    max-width: 760px;
    margin-left: auto;
    margin-right: auto;
}

.r2d-footer {
    padding: 60px 0 30px;
    border-top: 1px solid var(--r2d-border);
    background: #08130f;
    color: var(--r2d-muted);
    font-size: 0.9rem;
}

.r2d-footer__logo {
    height: 34px;
    margin-bottom: 16px;
}

.r2d-footer h6 {
    color: var(--r2d-text);
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-size: 0.75rem;
    font-weight: 700;
    margin-bottom: 14px;
}

.r2d-footer a,
.r2d-footer span {
    display: block;
    color: var(--r2d-muted);
    margin-bottom: 8px;
}

.r2d-footer a:hover {
    color: var(--r2d-accent);
    text-decoration: none;
}

.r2d-footer__bottom {
    border-top: 1px solid var(--r2d-border);
    padding-top: 22px;
    font-size: 0.8rem;
}

@keyframes r2d-float {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-8px);
    }
}

@keyframes r2d-drift {
    0%, 100% {
        transform: translate(0, 0);
    }
    50% {
        transform: translate(30px, -20px);
    }
}

@media (prefers-reduced-motion: reduce) {
    .r2d-landing *,
    .r2d-landing *::before,
    .r2d-landing *::after {
        animation: none !important;
    }
}

@media (max-width: 991px) {
    .r2d-nav-toggle {
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .r2d-nav {
        display: none;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        flex-direction: column;
        align-items: stretch;
        gap: 4px;
        padding: 16px 20px 20px;
        background: rgba(11, 26, 23, 0.98);
        border-bottom: 1px solid var(--r2d-border);
    }

    .r2d-nav--open {
        display: flex;
    }

    .r2d-nav a:not(.r2d-btn) {
        padding: 10px 0;
    }

    .r2d-hero__title {
        font-size: 2.2rem;
    }

    .r2d-hero {
        padding-top: 130px;
    }

    .r2d-visual {
        margin: 70px 0 20px;
    }

    .r2d-window {
        transform: none;
    }

    .r2d-toast {
        right: 10px;
    }

    .r2d-glass--whatsapp {
        left: 10px;
    }

    .r2d-stats {
        grid-template-columns: repeat(2, 1fr);
    }

    .r2d-stats__item:nth-child(2) {
        border-right: 0;
    }

    .r2d-stats__item:nth-child(-n+2) {
        border-bottom: 1px solid var(--r2d-border);
    }

    .r2d-steps {
        grid-template-columns: repeat(2, 1fr);
    }

    .r2d-showcase,
    .r2d-showcase--reverse {
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
        padding: 26px;
    }

    .r2d-showcase__icon {
        flex: 0 0 auto;
        width: 80px;
        height: 80px;
        font-size: 2rem;
        border-radius: 18px;
    }
}

@media (max-width: 575px) {
    .r2d-hero {
        padding-top: 120px;
    }

    .r2d-hero__title {
        font-size: 1.85rem;
    }

    .r2d-section__head h2,
    .r2d-cta h2 {
        font-size: 1.6rem;
    }

    .r2d-app__sidebar,
    .r2d-app__company,
    .r2d-window__url,
    .r2d-toast {
        display: none;
    }

    .r2d-app__filters {
        grid-template-columns: repeat(2, 1fr);
    }

    .r2d-app__lots {
        grid-template-columns: repeat(4, 1fr);
    }

    .r2d-app__counts {
        display: none;
    }

    .r2d-visual {
        margin-bottom: 60px;
    }

    .r2d-glass--whatsapp {
        right: 10px;
        bottom: -44px;
    }

    .r2d-steps {
        grid-template-columns: 1fr;
    }

    .r2d-section {
        padding: 60px 0;
    }
}
</style>
